import { createFileRoute } from '@tanstack/react-router';
import { MenuTitle } from '../../../types';

export const Route = createFileRoute('/_private-routes/youtube-cms/invoices')({
  staticData: {
    menuTitle: MenuTitle.YoutubeCMSInvoice
  }
});
